import React from 'react';
import Icon from '@ant-design/icons';

import { theme } from 'antd';

const Answer = () => {
  const { token } = theme.useToken();

  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 3.03088C3.22386 3.03088 3 3.25474 3 3.53088C3 3.80703 3.22386 4.03088 3.5 4.03088H10.5C10.7761 4.03088 11 3.80703 11 3.53088C11 3.25474 10.7761 3.03088 10.5 3.03088H3.5ZM3 6.53088C3 6.25474 3.22386 6.03088 3.5 6.03088H7.5C7.77614 6.03088 8 6.25474 8 6.53088C8 6.80703 7.77614 7.03088 7.5 7.03088H3.5C3.22386 7.03088 3 6.80703 3 6.53088ZM3.5 9.03088C3.22386 9.03088 3 9.25474 3 9.53088C3 9.80703 3.22386 10.0309 3.5 10.0309H10.5C10.7761 10.0309 11 9.80703 11 9.53088C11 9.25474 10.7761 9.03088 10.5 9.03088H3.5ZM14 2.53088C14 1.15017 12.8807 0.0308838 11.5 0.0308838H2.5C1.11929 0.0308838 0 1.15017 0 2.53088V11.5309C0 12.9116 1.11929 14.0309 2.5 14.0309H11.5C12.8807 14.0309 14 12.9116 14 11.5309V2.53088ZM2.5 1.03088H11.5C12.3284 1.03088 13 1.70246 13 2.53088V11.5309C13 12.3593 12.3284 13.0309 11.5 13.0309H2.5C1.67157 13.0309 1 12.3593 1 11.5309V2.53088C1 1.70246 1.67157 1.03088 2.5 1.03088Z"
        fill={token.colorPrimary}
      />
    </svg>
  );
};

const AnswerIcon = (props) => <Icon component={Answer} {...props} />;

export default AnswerIcon;
